<div class="view-switcher-container" [ngClass]="{'-disabled': disabled}">
  <ng-container *ngFor="let option of options;">
    <div *ngIf="!showOnlyInactive || !option?.active" class="item -{{ option?.color ?? VIEW_SWITCHER_COLOR.PRIMARY }}"
      [ngClass]="{'-inactive': !option?.active, '-spacer': showSpacer}" (click)="onClick(option)">
      <img class="icon" *ngIf="option?.icon"
        src="../../../../assets/images/{{ option?.icon }}" matTooltip="{{ option?.tooltip }}"
        [matTooltipPosition]="'above'">
      <img class="icon" *ngIf="option?.iconUrl"
        src="{{ option?.iconUrl }}" matTooltip="{{ option?.tooltip }}"
        [matTooltipPosition]="'above'">
    </div>
  </ng-container>
</div>